import { Component, Input } from '@angular/core';

@Component({
  selector: 'libero-custom-content-dropdown',
  templateUrl: './custom-content-dropdown.component.html',
  styleUrls: ['./custom-content-dropdown.component.scss'],
  standalone: false
})
export class CustomContentDropdownComponent {
  @Input() public header!: string;

  public toggled = false;

  public toggle(): void {
    this.toggled = !this.toggled;
  }
}
